"use strict";function insetAdjust$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.insetAdjust$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.screen.insetAdjust";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.18"},_a)),exports.insetAdjust$=insetAdjust$,exports.default=insetAdjust$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/screen/insetAdjust.js
// module id = 1077
// module chunks = 106